const Instructors = () => {
  return <div>Instructors</div>
}

export default Instructors
